<template>
  <ion-page>
    <master-layout @refreshPage="reRender" pageTitle="مشاهده و ویرایش سفارش">
      <Loading :is="!orderLoaded" v-if="!orderLoaded"></Loading>

      <div v-if="orderLoaded">
        <div v-if="order">
            <ion-card-content>
              <div class="d-flex-between">
                <div><i class="far fa-user"></i>&nbsp;{{ order.user.fullname }}</div>
                <div>{{ order.user.phone }}&nbsp;<i class="far fa-mobile"></i></div>
              </div>
              <hr>
              <div class="d-flex-between">
                <div>شماره سفارش :
                  <div>{{ order.order_number }}</div>
                </div>
                <div>
                  تاریخ ثبت :
                  <div>{{ order.created_date }}</div>
                </div>
              </div>
            </ion-card-content>
          <h5>آیتم های سفارش</h5>
          <div class="items mb-2">
              <orderItemEdit @itemChanged="(v)=>{setItem(v,index)}" @del_items="removeItem(index)" v-for="(item,index) in orderItems" :key="index" :item="item" :order="order"></orderItemEdit>
          </div>
          <div v-if="rewardItems.length">
            <h5>آیتم های جایزه</h5>
            <div class="items mb-2">
              <orderItemEdit @itemChanged="(v)=>{setItem(v,index)}" @del_items="removeItem(index)"
                             v-for="(item,index) in rewardItems" :key="index" :item="item"
                             :order="order"></orderItemEdit>
            </div>
          </div>
              <ion-card-content >
                <div v-if="orderStatus===-1 || orderStatus === -2">
                  <div class="form-group mb-1">
                    <label>افزودن محصول به سفارش</label>
                    <ali-ajax-select :on-change="getProduct" route="getProductForSelectAjax" title="محصولات"
                                     itemTitle="product_title" name="product_id" desc="جستجو محصول..."
                                     itemId="_id"></ali-ajax-select>
                  </div>
                    <button class="btn btn-warning" @click="AddItemToOrder()">افزودن</button>&nbsp;
                    <button v-if="false" class="btn btn-info" @click="AddItemToOrder(true)">افزودن به عنوان جایزه</button>
                </div>
                <div class="order_item_div">
                  <div>
                    <NumberInput v-if="order.status === -1 || order.status === -2"  name="product_discount" @input="(e)=>{product_discount=e}" v-model="product_discount" :value="product_discount" placeholder="تخفیف" />
                    <div v-else> <div>تخفیف </div>
                      {{product_discount}}</div>
                  </div>
                  <div>
                    <label>هزینه ارسال</label>
                    <div>{{shipping_cost}}</div>
                  </div>
                </div>
                <div>جمع کل :
                  <money v-if="order.status === -1 || order.status === -2" :number="order_total"></money>
                  <money v-else :number="order.total"></money>
                </div>
                <div v-if="orderStatus===-1 || orderStatus === -2" class="mt-1 mb-1">
                  <label>توضیحات شما برای مدیریت : </label>
                  <textarea name="visitor_description" v-model="order.visitor_description" class="form-control"></textarea>
                </div>
                <div v-else-if="order.visitor_description" class="mt-1 mb-1 visitor_description">
                  توضیحات شما برای مدیریت :
                  <div v-html="order.visitor_description"></div>
                </div>
                <div class="negative_margin">
                  <button class="btn btn-success" v-if="orderStatus===-1 || orderStatus===-2" @click="changeOrderItem()" >ویرایش اطلاعات سفارش</button>
                </div>
                <div class="mt-1">
                  <button class="btn btn-primary" @click="showFactor()">اشتراک فاکتور <i class="far fa-share"></i></button>
                </div>
                <div v-if="order.status === 1 && order.sales_supervisor_user_id && currentUser._id === order.sales_supervisor_user_id">
                  <AjaxForm :route="'confirmOrder/'+order._id">
                    <label>تایید سفارش به عنوان سرپرست فروش</label>
                    <input type="hidden" readonly name="duty" value="sales_supervisor">
                    <select autocomplete="off" class="form-control" name="status">
                      <option :selected="!order.sales_supervisor_confirm" value="0">بررسی نشده</option>
                      <option :selected="order.sales_supervisor_confirm === 1" value="1">تایید شده</option>
                      <option :selected="order.sales_supervisor_confirm === 2" value="2">رد شده</option>
                    </select>
                    <div class="form-group">
                      <textarea v-model="order.sales_supervisor_description" name="sales_supervisor_description" class="form-control description" placeholder="توضیحات شما.."></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary">تغییر وضعیت</button>
                  </AjaxForm>
                </div>

                <div v-if="order.status === 1 && order.sales_manager_user_id && currentUser._id === order.sales_manager_user_id">
                  <AjaxForm :route="'confirmOrder/'+order._id">
                    <label>تایید سفارش به عنوان مدیر فروش</label>
                    <input type="hidden" readonly name="duty" value="sales_manager">
                    <select autocomplete="off" class="form-control" name="status">
                      <option :selected="!order.sales_manager_confirm" value="0">بررسی نشده</option>
                      <option :selected="order.sales_manager_confirm === 1" value="1">تایید شده</option>
                      <option :selected="order.sales_manager_confirm === 2" value="2">رد شده</option>
                    </select>
                    <div class="form-group">
                      <textarea v-model="order.sales_manager_description" name="sales_manager_description" class="form-control description" placeholder="توضیحات شما.."></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary">تغییر وضعیت</button>
                  </AjaxForm>
                </div>
                <div class="mt-1" v-if="order.status === 1 && order.sales_manager_user_id && currentUser._id !== order.sales_manager_user_id">
                  <div v-if="!order.sales_manager_confirm"  class="alert alert-warning">بررسی نشده توسط مدیر فروش</div>
                  <div v-if="order.sales_manager_confirm === 1"  class="alert alert-success">تایید شده توسط مدیر فروش</div>
                  <div v-if="order.sales_manager_confirm === 2" class="alert alert-danger">رد شده توسط مدیر فروش</div>
                </div>
                <div v-if="order.status === 1 && order.sales_supervisor_user_id && currentUser._id !== order.sales_supervisor_user_id">
                  <div v-if="!order.sales_supervisor_confirm"  class="alert alert-warning">بررسی نشده توسط سرپرست فروش</div>
                  <div v-if="order.sales_supervisor_confirm === 1"  class="alert alert-success">تایید شده توسط سرپرست فروش</div>
                  <div v-if="order.sales_supervisor_confirm === 2" class="alert alert-danger">رد شده توسط سرپرست فروش</div>
                </div>
              </ion-card-content>

        </div>
        <div  v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
      </div>

    </master-layout>
  </ion-page>
</template>

<script>
import {
  alertController,IonCardContent,
  IonPage
} from '@ionic/vue';
import {showSystemNoti} from "@/shared/helper";
import {mapActions, mapGetters} from "vuex";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AliSelect from "@/components/aliSelect";
import Money from "@/components/Money";
import AjaxForm from "../../components/AjaxForm";
import NumberInput from "../../components/NumberInput";
import Loading from "../../components/Loading";
import orderItemEdit from "../../components/orderItemEdit";
import {openWebpage} from "../../shared/helper";


// import {getFormData} from '@/shared/helper'

export default {
  components: {
    AjaxForm,NumberInput,
    AliAjaxSelect,
    AliSelect,Loading,
    IonPage,IonCardContent,orderItemEdit,
    Money
  },
  data()
  {
    return {
      ability_confirm : false,
      currentDuty : 'visitor',
      confirm_status : false,
      duty : null,
      add_product: true,
      order: null,
      orderLoaded: false,
      orderItems: [],
      rewardItems : [],
      attr_items: [],
      product_discount: 0,
      shipping_cost: 0,
      customer_id: null,
      customer: null,
      product_id: null,
      product_select : null,
      attr: null,
      product_type: null,
      cars: [],
      car_id: null,
      discount_note: '',
      order_total: 0,
      orderStatus: null,
      use_products: [],
    }
  },
  async mounted()
  {
    this.duty = this.currentUser.original_duty;
  },
  async created()
  {
    this.duty = this.currentUser.original_duty;
    await this.init();
  },
  methods: {
    async init()
    {
      this.error = null;
      this.ability_confirm = false;
      this.confirm_status = null;
      this.id = this.$route.params.id;
      this.orderLoaded = false;
      this.order = null;
      this.product_discount = 0;
      this.shipping_cost = 0;
      this.orderItems = [];
      this.customer_id = null;
      this.orderStatus = null;
      this.use_products = [];
      const result = await this.getOrder(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.orderLoaded = true;
          this.order = result.order;
          const order = this.order;
          const duty = this.duty;
          if (duty === 'sales_supervisor' && order.sales_supervisor_user_id &&
          order.sales_supervisor_user_id.toString() === this.currentUser._id)
          {
            this.ability_confirm = true;
            this.confirm_status = order.sales_supervisor_confirm;
          }

          if (duty === 'sales_manager' && order.sales_manager_user_id &&
              order.sales_manager_user_id.toString() === this.currentUser._id)
          {
            this.ability_confirm = true;
            this.confirm_status = order.sales_manager_confirm;
          }



          this.product_discount = this.order.discount_amount;
          this.shipping_cost = this.order.shipping_cost;
          const order_items = result.order_items;
          for (let i = 0; i < order_items.length; i++)
          {
            if (order_items[i].unit_type === 'big')
            {
              order_items[i].bigger_unit_quantity = Number(JSON.stringify(order_items[i].real_quantity/order_items[i].quantity));
            }
          }

          this.orderItems = result.order_items;
          this.car_id = this.order.car_id;
          this.customer_id = this.order.user_id;
          this.orderStatus = this.order.status;
          // if (order.status === 0)
            await this.calculateOrderSum();
        }
        else
        {
          this.orderLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.orderLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    showFactor()
    {
      const url = process.env.VUE_APP_API_URL + '/providerOrder/factor/'+this.order._id;
      openWebpage(url);
    },

    ...mapActions("order", {
      getOrder: 'getOrder',
      addProductToOrder: 'addProductToOrder',
      editOrderItems: 'editOrderItems',
      addServiceToOrder: 'addServiceToOrder',
      checkProductToAddOrderEdit : 'checkProductToAddOrderEdit',
      finishOrderFunc : 'finishOrder',
    }),
    ...mapActions("app", {
      getProductVariableAttr: 'getProductVariableAttr'
    }),
    AddItemToOrder: async function (reward)
    {
      const p_select = this.product_select;
      if (p_select)
      {
        const out = {id : p_select._id,order_id : this.order._id};
        const check = await this.checkProductToAddOrderEdit(out);
        if (check.ok)
        {
          const item = check.item;
          item.new = true;
          //باید هم برای محصولات و هم برای جایزه ها چک برای تکراری نبودن بزارم

          if (reward)
          {
            const result = this.rewardItems.find(({product_id,attr_hash}) => (product_id === item.product_id)&& (attr_hash === item.attr_hash));
            if (result)
              return showSystemNoti('danger', 'محصول انتخاب شده در لیست کالاهای جایزه موجود می باشد.');
            // item.price = 0;
            // console.log()
            this.rewardItems.push(item);
          }
          else
          {
            const result = this.orderItems.find( ({ product_id,attr_hash }) => (product_id === item.product_id)&& (attr_hash === item.attr_hash) );
            if (result)
              return showSystemNoti('danger','محصول انتخاب شده در لیست کالاهای سفارش موجود می باشد.');
            this.orderItems.push(item);
          }
        }
        else
          return showSystemNoti('danger',check.error);
      }
      else
          return showSystemNoti('danger','محصول را انتخاب کنید.');
    },
    getProduct: async function (c)
    {
      if (c && c.length)
      {
        c = c[0];
        this.product_select = c;
      }
      else
      {
        this.product_select = null;
      }
    },
    reg_attr: async function (a)
    {
      if (a && a.length)
      {
        this.attr = a[0].hash;
      }
      else
        this.attr = null;
    },
    removeItem: function (index)
    {
      this.orderItems.splice(index, 1);
      this.calculateOrderSum();
    },
    changeOrderItemQuantity: function (event, index)
    {
      this.orderItems[index].quantity = (event.target.value)
      this.calculateOrderSum();
    },
    changeOrderItemPrice: function (event, index)
    {
      this.orderItems[index].price = (event.target.value)
      this.calculateOrderSum();
    },
    changeOrderItem: async function ()
    {
      const self = this;
      const order_items = this.orderItems;
      const product_discount = this.product_discount;
      if (!order_items.length)
        return showSystemNoti('danger', 'حداقل برای سفارش باید یک آیتم اضافه کنید.');

      let final_items = [];
      for (let i = 0; i < order_items.length; i++)
      {
        let item = {};
        item.real_quantity = order_items[i].real_quantity;
        item._id = order_items[i]._id;
        item.product_id = order_items[i].product_id;
        item.attr_hash = order_items[i].attr_hash;
        final_items.push(item);
      }


      let out = {
        visitor_description : this.order.visitor_description,
        items: final_items,
        rewards_items : this.rewardItems,
        order_id: this.order._id,
        discount_amount: product_discount,
      };
      const check = await this.editOrderItems(out);
      if (check.ok)
      {
        await self.init();
        return showSystemNoti('success', check.message)
      }
      else
        return showSystemNoti('danger', check.error);

    },
    calculateOrderSum: async function ()
    {
      const orderItems = this.orderItems;

      let total = 0;
      for (let i = 0; i < orderItems.length; i++)
      {
        let quantity = orderItems[i].real_quantity;
        let price = orderItems[i].small_price;
        if (!quantity || isNaN(quantity))
        {
          orderItems[i].total = 0;
        }
        else
        {
          orderItems[i].total = parseInt(quantity) * parseInt(price);
          total += orderItems[i].total;
        }
        this.orderItems[i] = orderItems[i];
      }
      if(isNaN(this.shipping_cost))
        this.shipping_cost = 0;
      if(!this.product_discount || isNaN(this.product_discount))
        this.product_discount = 0;
      this.order_total = total + parseInt(this.shipping_cost) - parseInt(this.product_discount);

    },
    finishOrder: async function ()
    {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'سفارش به حالت تمام شده تغییر وضعیت داشته باشد',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  await this.finishOrderConfirm();
                },
              },
            ],
          });
      return alert.present();
    },
    async finishOrderConfirm()
    {
      const self = this;
      const current_km = this.current_km;
      const used_oil = this.used_oil;
      const use_products = this.use_products;
      const out = {
        current_km: current_km,
        used_oil: used_oil,
        use_products: use_products,
        order_id : this.order._id,
        debt : this.order.debt,
        days_for_next_visit : this.daysForNextVisit,
        pay_type : this.pay_type.val
      };
      let check = await this.finishOrderFunc(out);
      if (check.ok)
      {
        // this.order.status = 1;
        return showSystemNoti('success',check.message,async function ()
        {
          await self.init();
        });
      }
      else
        return showSystemNoti('danger',check.error);
    },
    changeUnit(event, index)
    {
      const val = event.target.value;

      const product = this.orderItems[index];
      if (val === 'small')
        product.price = product.price / product.bigger_unit_quantity;
      else
        product.price = product.price * product.bigger_unit_quantity;
      this.calculateOrderSum();
    },
    setItem(newItem,index)
    {
      this.orderItems[index] = newItem;
      this.calculateOrderSum();
    },
    reRender()
    {
      this.init();
    }
  },
  watch: {
    add_product: function ()
    {
      this.product_id = null;
      this.service_id = null;
      this.attr = null;
    },
    product_discount: function ()
    {
      this.calculateOrderSum();
    },
    shipping_cost: function ()
    {
      this.calculateOrderSum();
    },
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('order/view/') >= 0 && oldUrl.toLowerCase().indexOf('order/view/') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  },
  computed: {
    ...mapGetters("auth", {
      currentUser: "getUserInfo",
    }),
  },
}
</script>

<style scoped>
.visitor_description
{
  border: 2px dashed silver;
  padding: 5px;
  border-radius: 4px;
}
.quantity-input {
  width: 50px;
}
.del-btn {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 20px;
  padding: 6px;
  cursor: pointer;
}
.d-flex-between {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.order_item_div
{
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-bottom: 9px;
  align-self: center;
}
.order_item_div > div
{
  align-self: center;
}
.del-btn
{
  background: transparent;
}
.order-items
{
  background: #CFD8DC;
  color: #222222;
}
.h6{
  font-size: 15px;
  font-weight: 900;
  color: black;
}
.negative_margin {
  margin: 0 -15px;
  text-align: center;
}
.items{
  overflow-x: auto;
  background: #c0c0c091;
  border-radius: 0;
  white-space: nowrap;
  display: flex;
}
.order-items
{
  background: #CFD8DC;
  color: #222222;
  margin: 5px !important;
  min-width: 270px;
}
.order_item_div > span
{
  white-space: break-spaces;
}
.input_label{
  width: 85px;
  text-align: right;
}
.description
{
  height: 120px;
}
.mb-1
{
  margin-bottom: 5px;
}
</style>